import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import DeckService from "../../../../services/catalogs/DeckService";

export const REQUEST_FETCH_DECK = "REQUEST_FETCH_DECK";
export const FETCH_DECK_SUCCESS = "FETCH_DECK_SUCCESS";
export const FETCH_DECK_ERROR = "FETCH_DECK_ERROR";
export const INITIAL_STATE_DECK = "INITIAL_STATE_DECK";

function requestFetchDeck() {
  return {
    type: REQUEST_FETCH_DECK,
  };
}

function fetchDeckSuccess(json) {
  return {
    type: FETCH_DECK_SUCCESS,
    deck: json.data,
  };
}

function fetchDeckError(json) {
  return {
    type: FETCH_DECK_ERROR,
    error: json.data,
  };
}

export function initialStateDeck() {
  return {
    type: INITIAL_STATE_DECK,
  };
}

export function fetchDeck(deck_id) {
  return (dispatch) => {
    dispatch(requestFetchDeck());
    return DeckService.getDeck(deck_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchDeckSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchDeck(deck_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchDeckError(json.data));
      }
    });
  };
}
